import { isTourFlightUpsellAvailable } from 'checkout/selectors/tourFlightSelectors'
import qs from 'qs'
import { addItem } from 'actions/CheckoutActions'
import type { AppAction } from 'actions/types/ActionTypes'
import { TOUR_FLIGHT_SEARCH_FIXTURE } from 'checkout/fixtures/tourFlightSearch'
import { generatePassengersFromOccupants } from 'checkout/lib/utils/flights/passenger'
import { getNonCharterFlightItems } from 'checkout/selectors/view/flights'
import { fareClassToUrlMap } from 'constants/flight'
import { generateFlightCheckoutItem } from 'lib/checkout/flights/cart'

/** Reuse a leg's draft on back navigation; never bundle it with the tour price. */
export function prepareTourFlightLeg(leg: 'departing' | 'returning'): AppAction {
  return (dispatch, getState) => {
    if (!isTourFlightUpsellAvailable(getState())) return

    // TODO: use the actual search data from the server
    const search = TOUR_FLIGHT_SEARCH_FIXTURE[leg]
    const itinerary = search.itinerary[0]
    let item = getNonCharterFlightItems(getState()).find(item => item.tourFlightLeg === leg)
    if (!item) {
      item = {
        ...generateFlightCheckoutItem({
          originAirportCode: itinerary.departureAirport,
          destinationAirportCode: itinerary.arrivalAirport,
          occupants: search.occupancies[0],
          passengers: generatePassengersFromOccupants(search.occupancies[0]),
          fareType: search.fareType,
          viewType: search.viewType,
          selectedCabinClass: search.fareClass,
        }),
        tourFlightLeg: leg,
      }
      dispatch(addItem(item))
    }
    return qs.stringify({
      flightItemId: item.itemId,
      originAirportCode: item.originAirportCode,
      destinationAirportCode: item.destinationAirportCode,
      departDate: itinerary.departureDate,
      fareClass: fareClassToUrlMap[search.fareClass],
    })
  }
}
